__turbopack_context__.v({
  "clamp": "_1xrwLq_clamp" + " " + __turbopack_context__.i(7213)["lineClamp"],
  "paragraphStyles": "_1xrwLq_paragraphStyles",
});
